<script setup>
import { Switch, SwitchLabel, SwitchGroup } from "@headlessui/vue";
import { ErrorMessage, Field } from "vee-validate";

const {
  fieldId,
  fieldName,
  label,
  disabled = false,
  required = false,
  inline = false,
} = defineProps({
  fieldId: {
    type: String,
    required: true,
  },
  fieldName: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  required: {
    type: Boolean,
    required: false,
  },
  inline: {
    type: Boolean,
    required: false,
  },
});

const model = defineModel();
</script>

<template>
  <SwitchGroup
    as="div"
    class="mb-4 flex"
    :class="{
      'flex-col': !inline,
      'flex-row-reverse justify-end': inline,
    }"
  >
    <SwitchLabel
      v-if="label"
      :class="{ 'mb-2': !inline, 'ml-2': inline }"
    >
      {{ label }}
      <sup v-if="required" class="text-red-500">*</sup>
    </SwitchLabel>

    <Field
      v-model="model"
      :id="fieldId"
      :name="fieldName"
      class="rounded border border-gray-300 px-5 py-3 placeholder:text-gray-400 focus:border-transparent focus:ring-gray-500 disabled:cursor-not-allowed disabled:bg-gray-100"
    >
      <Switch
        v-model="model"
        :class="model ? 'bg-blue-600' : 'bg-gray-200'"
        class="relative inline-flex h-6 w-11 items-center rounded-full disabled:opacity-40"
        :disabled="disabled"
      >
        <span
          :class="model ? 'translate-x-6' : 'translate-x-1'"
          class="inline-block h-4 w-4 transform rounded-full bg-white transition"
        />
      </Switch>
    </Field>

    <ErrorMessage :name="fieldName" class="mt-1 text-sm text-red-500" />
  </SwitchGroup>
</template>
